export const DIM = {
  defaultFontSize: 14,
  screenPadding: 16,
  sectionPadding: 20,
  inputHeight: 50,
  headerHeight: 56,
  bottomNavigationHeight: 70,
};
